import { ProviderDatabase } from "../../../../types";
import useDeleteProvider from "../../api/useDeleteProvider";
import ConfirmDeleteDialog from "../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog";

type Props = {
  provider: ProviderDatabase;
  onClose: () => void;
  afterSuccess?: () => void;
}

export default function DeleteProviderModal(props: Props) {
  const { mutateAsync } = useDeleteProvider();

  async function handleConfirm() {
    await mutateAsync(props.provider.id);
    props.afterSuccess?.();
  }

  return (
    <ConfirmDeleteDialog
      title="Supprimer le prestataire"
      onConfirm={handleConfirm}
      onClose={props.onClose}
    >
      Êtes-vous sûr de vouloir supprimer le prestataire « {props.provider.name} » ?
    </ConfirmDeleteDialog>
  );
}
